import React from 'react';

import type { UIFacetOption } from 'src/components/types/UIFacet';
import type { UISortOption } from 'src/components/types/UISortOption';
import * as styles from './FacetHeader.styles';

interface FacetHeaderProps {
  heading: string;
  options?: UIFacetOption[] | UISortOption[];
}

const getActiveOptions = (options: (UIFacetOption | UISortOption)[]) =>
  options.filter((option) => option.active);

const areAllOptionsActive = (activeCount: number, total: number) =>
  activeCount > 0 && activeCount === total;

const areAllOptionsDisabled = (options: (UIFacetOption | UISortOption)[]) =>
  options.length > 0 && options.every((option) => ('count' in option ? option.count === 0 : false));

export const FacetHeader = ({ heading, options = [] }: FacetHeaderProps) => {
  const activeOptions = getActiveOptions(options);
  const activeCount = activeOptions.length;
  const allOptionsActive = areAllOptionsActive(activeCount, options.length);
  const allOptionsDisabled = areAllOptionsDisabled(options);

  const ariaChecked = activeCount === 0 ? 'false' : allOptionsActive ? 'true' : 'mixed';
  const ariaHidden = options.length > 0 ? (allOptionsDisabled ? 'true' : 'false') : undefined;

  return (
    <div aria-checked={ariaChecked} aria-hidden={ariaHidden} css={styles.headerWrapper}>
      <h4>
        {heading}
        {activeCount >= 2 && <span css={styles.count}>({activeCount})</span>}
      </h4>
      {activeCount === 1 && <h5>{activeOptions[0].title}</h5>}
    </div>
  );
};
